import { render, staticRenderFns } from "./config.vue?vue&type=template&id=88274036&scoped=true&"
import script from "./config.vue?vue&type=script&lang=ts&"
export * from "./config.vue?vue&type=script&lang=ts&"
import style0 from "./config.vue?vue&type=style&index=0&id=88274036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88274036",
  null
  
)

export default component.exports